export const htmlId: string = 'document-list-view';